import axios from 'axios'
import React, { useEffect, useState, useContext } from 'react'
import {
  Modal,
  Button,
  ToggleButtonGroup,
  ToggleButton,
  Alert,
} from 'react-bootstrap'
import { AuthContext } from '../AuthContext'
import * as dayjs from 'dayjs'

const ExportDataToEmail = ({
  exportDataToEmailModalShow,
  setExportDataToEmailModalShow,
  patient_id,
}) => {
  const [isLoading, setisLoading] = useState(false)
  const [email, setEmail] = useState(null)
  const end_date = dayjs()
  const [start_date, setStart_date] = useState(end_date.subtract(6, 'day'))
  const { baseUrl, sendDiscordNotification, currentUser, extendCookie } =
    useContext(AuthContext)
  const getInfoUrl = '/api/crm/clinic/info'
  const exportBloodPressure = '/api/crm/patient/measure/exportBloodPressure'

  const [myAlert, setMyAlert] = useState({
    show: false,
    msg: '',
    success: false,
  })
  useEffect(() => {
    console.log('start_date', start_date)
    console.log('end_date', end_date.add(1, 'day'))
  }, [start_date])

  useEffect(() => {
    axios
      .get(baseUrl + getInfoUrl, {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          Accept: '*/*',
          session: currentUser.session,
        },
      })
      .then((res) => {
        console.log('getInfo', res.data)
        setEmail(res.data.email)
        extendCookie()
      })
      .catch((e) => {
        console.log('getInfo error', e)
        sendDiscordNotification(`getInfo Error \n Error: ${e}`)
        alert('伺服器忙線中，請稍後再試')
      })
  }, [])

  // useEffect(() => {
  //   function simulateNetworkRequest() {
  //     return new Promise((resolve) => setTimeout(resolve, 2000))
  //   }

  //   if (isLoading) {
  //     simulateNetworkRequest().then(() => {
  //       setisLoading(false)
  //       setExportDataToEmailModalShow(false)
  //     })
  //   }
  // }, [isLoading])
  console.log('currentUser', currentUser)

  const handleClick = () => {
    if (currentUser && currentUser.session) {
      axios
        .post(
          baseUrl + exportBloodPressure,
          {
            patient_id: patient_id,
            start_date: start_date.format('YYYY-MM-DD'),
            end_date: end_date.add(1, 'day').format('YYYY-MM-DD'),
          },
          {
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
              Accept: '*/*',
              session: currentUser.session,
            },
          }
        )
        .then((res) => {
          if (res.data) {
            console.log('exportBloodPressure', res.data)
            if (res.data.message === '已成功寄出') {
              setMyAlert({
                show: true,
                msg: '已成功匯出至信箱',
                success: true,
              })
              setTimeout(() => {
                setMyAlert({
                  show: false,
                  msg: '',
                  success: false,
                })
                setExportDataToEmailModalShow(false)
              }, 3000)
              extendCookie()
            } else {
              setMyAlert({
                show: true,
                msg: '伺服器忙線中，請稍後再試',
                success: false,
              })
              setTimeout(() => {
                setMyAlert({
                  show: false,
                  msg: '',
                  success: false,
                })
              }, 3000)
            }
          }
        })
        .catch((e) => {
          console.log('exportBloodPressure error', e)
          sendDiscordNotification(`exportBloodPressure Error \n Error: ${e} `)
          setMyAlert({
            show: true,
            msg: '伺服器忙線中，請稍後再試',
            success: false,
          })
          setTimeout(() => {
            setMyAlert({
              show: false,
              msg: '',
              success: false,
            })
          }, 3000)
        })
        .finally(() => {})
    }
  }

  return (
    <>
      <Modal
        show={exportDataToEmailModalShow}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body className="">
          {/* TODO: getInfo */}
          <h4>匯出至信箱：{email}</h4>
          <h6 className="text-secondary">請選擇日期範圍，預設值為一週</h6>
          <ToggleButtonGroup
            className="my-3"
            type="radio"
            name="scopes"
            defaultValue={1}
          >
            <ToggleButton
              disabled={isLoading}
              variant="outline-primary"
              id="week"
              value={1}
              onClick={() => {
                setStart_date(end_date.subtract(1, 'week'))
              }}
            >
              一週
            </ToggleButton>
            <ToggleButton
              disabled={isLoading}
              variant="outline-primary"
              id="month"
              value={2}
              onClick={() => {
                setStart_date(end_date.subtract(2, 'week'))
              }}
            >
              兩週
            </ToggleButton>
            <ToggleButton
              disabled={isLoading}
              variant="outline-primary"
              id="threeMonthes"
              value={3}
              onClick={() => {
                setStart_date(end_date.subtract(1, 'month'))
              }}
            >
              一個月
            </ToggleButton>
          </ToggleButtonGroup>
          {myAlert.show && (
            <Alert
              className="mt-3"
              variant={myAlert.success ? 'success' : 'danger'}
              onClose={() =>
                setMyAlert({ show: false, msg: '', success: false })
              }
              dismissible
            >
              {myAlert.msg}
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-primary"
            onClick={() => {
              setExportDataToEmailModalShow(false)
            }}
            disabled={isLoading}
          >
            取消
          </Button>
          <Button
            onClick={
              // TODO POST
              !isLoading ? handleClick : null
            }
            disabled={isLoading}
          >
            {isLoading ? '匯出中…' : '確認匯出'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default ExportDataToEmail
